module.exports = __webpack_public_path__ + "static/support-mail-a1f30dfd97f26bbc5a14f029fbcc3f67.svg";